import React, { Component, Fragment } from "react";
import { BrowserRouter, Route, Switch, Redirect } from "react-router-dom";
import App from "../../components/app";
import store from "store";
// Import custom Components

import MainApp from "../../routes/index";
import Signin from "./../auth/signin";
//firebase Auth
import AuthenticationService from "../../services/authenticationService";
import GlobalFonts from "../../components/common/globalFonts";
const RestrictedRoute = ({
  component: Component,
  trainee,
  authUser,
  ...rest
}) => (
  <Route
    {...rest}
    render={(props) =>
      authUser ? (
        <Component {...props} />
      ) : (
        <Redirect
          to={{
            pathname: "/login",
            state: { from: props.location },
          }}
        />
      )
    }
  />
);
class Main extends Component {
  componentDidMount() {
    if (store.get("authToken") && store.get("authToken") !== null) {
      AuthenticationService.checkPing().then((response) => {
        // this.setState({ connection: true, AESKey: response });
        console.log({ response });
      });
    }
    // AuthenticationService.socketConnect().then(response => {
    //   // this.setState({ connection: true, AESKey: response });
    //   //console.log({ response });
    // });
  }
  render() {
    const { match, location } = this.props;

    //console.log({ location });
    if (location.pathname === "" || location.pathname === "/") {
      if (store.get("authToken") && store.get("authToken") !== null) {
        return <Redirect to={"/products/all"} />;
      } else {
        return <Redirect to={"/login"} />;
      }
    }
    return (
      <Fragment>
        <GlobalFonts />
        <Switch>
          <Route path={`${process.env.PUBLIC_URL}/login`} component={Signin} />
          {store.get("authToken") ? (
            <Fragment>
              <App style={{ fontFamily: "proxima" }}>
                {/* dashboard menu */}
                <RestrictedRoute
                  path={`${match.url}`}
                  authUser={store.get("authToken")}
                  accessToken={store.get("authToken")}
                  component={MainApp}
                />
                {/* <Route
                  exact
                  path={`${process.env.PUBLIC_URL}/`}
                  render={() => {
                    return (
                      <Redirect
                        to={`${process.env.PUBLIC_URL}/dealers/inbox`}
                      />
                    );
                  }}
                /> 
                <Route
                  path={`${process.env.PUBLIC_URL}/products/all`}
                  component={ProductionDefault}
                />
                <Route
                  path={`${process.env.PUBLIC_URL}/dealers/inbox`}
                  component={ProductionDetected}
                /> */}
              </App>
            </Fragment>
          ) : (
            <Redirect to={`${process.env.PUBLIC_URL}/login`} />
          )}
        </Switch>
      </Fragment>
    );
  }
}

export default Main;
